class Template
{
	Menu()
	{
		const menuNav		= $('header#MainHeader .MainMenu');
		const openMenu 		= $('header#MainHeader .MainBar .actionMenu button');

		const mainNav = $('header#MainHeader .MainMenu .MainNav');

		openMenu.click(function(event)
		{
			if(menuNav.hasClass('Opened'))
				$('body').css({'overflow':'auto'});
			else
				$('body').css({'overflow':'hidden'});

			menuNav.toggleClass('Opened');
			event.stopPropagation();
		});

		$(document).click(function(event)
		{
			if (menuNav.hasClass('Opened') && !mainNav.is(event.target) && !mainNav.has(event.target).length)
				menuNav.removeClass('Opened');
		});

		$(document).keydown(function(event)
		{
			if (event.key === "Escape" && menuNav.hasClass('Opened'))
				menuNav.removeClass('Opened');
		});
	}

	static setHeaderPosition(pos)
	{
		const headerBar = $('#MainHeader .MainBar');
		const backgroundBar = $('#MainHeader .MainBar .BgMainBar');

		if(pos >= 36)
			headerBar.css({'top':0,'position':'fixed'});
		else
			headerBar.css({'top':'inherit','position':'relative'});

		if(pos >= 10)
			backgroundBar.addClass('BackdropBlur');
		else
			backgroundBar.removeClass('BackdropBlur');
	}

	HeaderScroll()
	{
		if($(window).width() > 1366 && $('#MainHeader.HasExtraBar').length > 0)
		{
			Template.setHeaderPosition($(window).scrollTop())
			
			$(window).on('scroll', function()
			{
				Template.setHeaderPosition($(this).scrollTop())
			});
		}
	}

	ScrollTo()
	{
		function ScrollToElement(href)
		{
			let hash = '#'+href.split('#/')[1];
			let altura = $(hash).offset().top - 100;

			window.location = href;

			$('.scrollTo').removeClass('current-page-item');
			$(this).addClass('current-page-item');

			if(altura)
			{
				window.scroll({
					top: altura,
					behavior: 'smooth'
				});
			}
		}
		
		$('.scrollTo').each(function()
		{
			$(this).click(function(e)
			{
				e.preventDefault();

				ScrollToElement($(this).attr('href'));
			});
		});

		let HASH = window.location.hash;

		if(HASH)
		{
			ScrollToElement(HASH);
		}

	}

	Share()
	{
		$('.shareContent').each(function()
		{
			const button = $(this);
			const conteudo_url = $(this).data('url');
			const conteudo_titulo = $(this).data('titulo');
			const conteudo_imagem = $(this).data('imagem');
			const conteudo_release = $(this).data('release');

			button.click(function()
			{
				if (navigator.share)
					try
					{
						const shareData = {
							title: 'Compartilhar: ' + conteudo_titulo,
							text: conteudo_release + '. Veja mais: ',
							url: conteudo_url,
						}

						// console.log(shareData)

						navigator.share(shareData);
					}
					catch (err)
					{
						console.log('Error: ', err);
					}
			})
		})
	}

	ResponsiveIframe()
	{
		if($('.CCSinglePost .Post p').length > 0)
		{
			$('.CCSinglePost .Post p').each(function()
			{
				if($(this).find('iframe').length > 0)
					$(this).addClass('ResponsiveIframe');
			})
		}
	}

	init()
	{
		const self = this;

		self.Menu();
		self.HeaderScroll();
		self.ScrollTo();
		self.Share();
		self.ResponsiveIframe();

		window.addEventListener("resize", function ()
		{
			self.HeaderScroll();
		});
	}
}

export default Template;